import type { SVGAttributes } from 'react'

export interface LivePhotoIconProps extends SVGAttributes<SVGSVGElement> {}

export default function LivePhotoIcon({ ...props }: LivePhotoIconProps) {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<circle cx="11.9164" cy="12" r="3" stroke="black" strokeWidth="1.8" />
			<circle cx="11.9164" cy="12" r="6.4791" stroke="black" strokeWidth="1.8" />
			<circle cx="12" cy="2.49901" r="0.9" fill="black" />
			<circle cx="12" cy="21.5009" r="0.9" fill="black" />
			<circle
				cx="2.49908"
				cy="11.9999"
				r="0.9"
				transform="rotate(-90 2.49908 11.9999)"
				fill="black"
			/>
			<circle
				cx="21.5009"
				cy="11.9999"
				r="0.9"
				transform="rotate(-90 21.5009 11.9999)"
				fill="black"
			/>
			<circle
				cx="3.77199"
				cy="7.24948"
				r="0.9"
				transform="rotate(-60 3.77199 7.24948)"
				fill="black"
			/>
			<circle
				cx="20.228"
				cy="16.7504"
				r="0.9"
				transform="rotate(-60 20.228 16.7504)"
				fill="black"
			/>
			<circle
				cx="7.24952"
				cy="20.228"
				r="0.9"
				transform="rotate(-150 7.24952 20.228)"
				fill="black"
			/>
			<circle
				cx="16.7504"
				cy="3.7719"
				r="0.9"
				transform="rotate(-150 16.7504 3.7719)"
				fill="black"
			/>
			<circle
				cx="3.77195"
				cy="16.7504"
				r="0.9"
				transform="rotate(-120 3.77195 16.7504)"
				fill="black"
			/>
			<circle
				cx="20.2281"
				cy="7.24947"
				r="0.9"
				transform="rotate(-120 20.2281 7.24947)"
				fill="black"
			/>
			<circle
				cx="16.7505"
				cy="20.228"
				r="0.9"
				transform="rotate(150 16.7505 20.228)"
				fill="black"
			/>
			<circle
				cx="7.24954"
				cy="3.7719"
				r="0.9"
				transform="rotate(150 7.24954 3.7719)"
				fill="black"
			/>
			<circle
				cx="5.28189"
				cy="18.7181"
				r="0.9"
				transform="rotate(-135 5.28189 18.7181)"
				fill="black"
			/>
			<circle
				cx="18.7182"
				cy="5.28177"
				r="0.9"
				transform="rotate(-135 18.7182 5.28177)"
				fill="black"
			/>
			<circle
				cx="18.7182"
				cy="18.7181"
				r="0.9"
				transform="rotate(135 18.7182 18.7181)"
				fill="black"
			/>
			<circle
				cx="5.28186"
				cy="5.28178"
				r="0.9"
				transform="rotate(135 5.28186 5.28178)"
				fill="black"
			/>
			<circle cx="9.541" cy="21.1771" r="0.9" transform="rotate(-165 9.541 21.1771)" fill="black" />
			<circle
				cx="14.459"
				cy="2.82275"
				r="0.9"
				transform="rotate(-165 14.459 2.82275)"
				fill="black"
			/>
			<circle
				cx="21.1772"
				cy="14.459"
				r="0.9"
				transform="rotate(105 21.1772 14.459)"
				fill="black"
			/>
			<circle
				cx="2.82286"
				cy="9.54092"
				r="0.9"
				transform="rotate(105 2.82286 9.54092)"
				fill="black"
			/>
			<circle
				cx="14.459"
				cy="21.1771"
				r="0.9"
				transform="rotate(165 14.459 21.1771)"
				fill="black"
			/>
			<circle cx="9.541" cy="2.82276" r="0.9" transform="rotate(165 9.541 2.82276)" fill="black" />
			<circle
				cx="21.1772"
				cy="9.54093"
				r="0.9"
				transform="rotate(75 21.1772 9.54093)"
				fill="black"
			/>
			<circle cx="2.82286" cy="14.459" r="0.9" transform="rotate(75 2.82286 14.459)" fill="black" />
		</svg>
	)
}
